import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { HoverTooltip } from '@/components/common/HoverTooltip/HoverTooltip';
import { getGoogleMapsPlaceUrl } from '@/components/doohReport/common/helpers/googleMaps.helper';

import type { DoohReportLocation } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

type Props = {
  id: string;
  location: DoohReportLocation | null;
  onShowDetails: () => void;
};

/**
 * Row actions of an event: the eye opens its audience details and the external link opens the
 * event venue in Google Maps in a new tab (hidden when the event has no coordinates).
 */
export default function EventActions({ id, location, onShowDetails }: Readonly<Props>) {
  const { formatMessage } = useIntl();

  return (
    <span className="contextEvents__colActions" data-row-action>
      <HoverTooltip
        content={formatMessage({
          defaultMessage: 'Event audience details',
          id: 'doohReport.contextEvents.audienceDetails.title'
        })}
      >
        <span>
          <ButtonUI
            className="contextEvents__actionButton contextEvents__actionButton--eye"
            icon="fa-regular fa-eye"
            id={`${id}-details`}
            onClick={onShowDetails}
            shape="link"
            size="small"
            type="secondary"
          />
        </span>
      </HoverTooltip>
      {location && (
        <HoverTooltip
          content={formatMessage({ defaultMessage: 'View event on map', id: 'doohReport.contextEvents.viewOnMap' })}
        >
          <span>
            <ButtonUI
              className="contextEvents__actionButton"
              icon="fa-regular fa-arrow-up-right-from-square"
              id={`${id}-map`}
              onClick={() => window.open(getGoogleMapsPlaceUrl(location), '_blank', 'noopener,noreferrer')}
              shape="link"
              size="small"
              type="secondary"
            />
          </span>
        </HoverTooltip>
      )}
    </span>
  );
}
